export class Content {
  private static instance: Content
  public static getInstance(): Content {
    if (!Content.instance) {
      Content.instance = new Content()
    }
    return Content.instance
  }

  private static FONT_SIZES: { [MIN_WIDTH: string]: { value: number; unit: string } } = {}
  COLS = 12
  CONTENT_TYPES = {}
  private FAVOURITE_COLORS: string[] = []

  setCols(cols: number) {
    return (this.COLS = cols)
  }
  setMaxWidth(cols: number) {
    return (this.COLS = cols)
  }
  getColors() {
    return this.FAVOURITE_COLORS
  }
  setColors(colors: string[]) {
    return (this.FAVOURITE_COLORS = colors)
  }
  setFontSizes(fontSizes: { [key: string]: { value: number; unit: string } }) {
    Content.FONT_SIZES = fontSizes
  }
  getFontSizes() {
    return Content.FONT_SIZES
  }
}
